import React, { useContext, useEffect, useState } from 'react';
import style from "./EventSticker.module.css";
import { BrowserDetectContext } from 'providers/BrowserEventProvider';

const EventSticker = ({ isEvent, discount, price }) => {
    const { isMobile } = useContext(BrowserDetectContext);
    const now = new Date();
    const [activeEvent, setActiveEvent] = useState(false);
    const [discountRate, setDiscountRate] = useState();

    useEffect(() => {

        if (isEvent) {

            const start = new Date(isEvent.start_date);
            const end = new Date(isEvent.end_date);
            const eventYn = start <= now && now <= end;
            setActiveEvent(eventYn);

        }
    }, [isEvent])
    useEffect(() => {
        if (discount) {
            const calDiscountRate = ((price - discount) / price) * 100;
            setDiscountRate(calDiscountRate)
        }
    }, [discount])

    return (
        <div className={style.eventContainer}>

            {
                activeEvent &&

                    isMobile
                    ?
                    <div key={isEvent && isEvent.id} className={style.eventTagContainer}>
                        {
                            isEvent &&
                            <span className={style.mobileEventTagNPlusM}>
                                {`${isEvent.N} + ${isEvent.M}`}
                            </span>

                        }
                        {
                            isEvent &&
                            <span
                                className={isEvent.cross ? style.mobileEventTagCross : style.mobileEventTagNoCross}
                            >
                                {isEvent.cross ? "교차" : "비교차"}
                            </span>
                        }
                        {
                            discountRate &&
                            <span
                                className={style.mobileDiscount}
                                style={{ fontSize: "9px !important" }}
                            >
                                {discountRate} {`%`}
                            </span>
                        }

                    </div>
                    :

                    <div key={isEvent && isEvent.id} className={style.eventTagContainer}>
                        {
                            isEvent &&
                            <span className={style.eventTagNPlusM}>
                                {`${isEvent && isEvent.N} + ${isEvent && isEvent.M}`}
                            </span>

                        }
                        {
                            isEvent &&
                            <span
                                className={isEvent.cross ? style.eventTagCross : style.eventTagNoCross}
                            >
                                {isEvent.cross ? "교차" : "비교차"}
                            </span>
                        }
                        {discountRate &&
                            <span
                                className={isMobile ?style.mobileDiscount :style.discount}
                            >
                                {discountRate} {`%`}
                            </span>
                        }

                    </div>
            }
        </div>
    );
};

export default EventSticker;
